import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Are you sure?",
  message,
  onConfirm,
  onCancel,
  confirmText = "Delete",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle sx={{ backgroundColor: "#161B22", color: "#fff" }}>{title}</DialogTitle>
      <DialogContent sx={{ backgroundColor: "#161B22" }}>
        <DialogContentText sx={{ color: "#A8B2D1" }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "#161B22" }}>
        <Button onClick={onCancel} sx={{ color: "#A8B2D1" }}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
